<template>
  <div v-if="showBanner" class="d-flex justify-content-center mx-2 mx-sm-0">
    <div class="banner d-flex align-items-center">
      <img :src="`${store.baseUrl}/images/icon_alert.png`" alt="">
      <p>Your Card has new and enhanced benefits. <a :href="`${store.baseUrl}/en-us/${store.selectedCard.url_path}-benefits`" class="link-1 bold text-decoration-none no-wrap" target="_blank">Learn more</a>.</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from '../store';
const store = useStore();

const showBanner = computed(() => {
  if (
    store.selectedCard.version === 'business' && store.showSmallBusinessBanner ||
    store.selectedCard.version === 'brilliant' && store.showSmallBrilliantBanner
  ) {
    return true;
  } else {
    return false;
  }
});
</script>
